import React from "react";
import { useDrop } from "react-dnd";
import { NativeTypes } from "react-dnd-html5-backend";
import AssetDropZone from "./AssetDropZone";
import AppConfig from "../../config/app";
import { generateDropSpec } from "../../utils/DnDUtils";
import { assetPanelDrop } from "./AssetDropHandlers";

const { FILE } = NativeTypes;

const AssetDropContainer = ({ children, selectedFolder = {} } = {}) => {
  const drop = generateDropSpec({
    type: FILE,
    onDrop: assetPanelDrop({ folder_id: selectedFolder?.folder_id }),
  });

  const [{ isOver }, dropRef] = useDrop(drop);

  const style = {
    display: "flex",
    flex: "1 1 auto",
    overflowY: "auto",
    minHeight: 0,
    position: "relative",
  };

  if (AppConfig.demoMode) {
    return <div style={style}>{children}</div>;
  }

  return (
    <div id="asset-drop-zone" style={style} ref={dropRef}>
      {children}
      <AssetDropZone visible={isOver} />
    </div>
  );
};

export default AssetDropContainer;
